import { Avatar, Stack } from '@mui/material';
import { Title } from './Title';
import { Contacts } from './Contacts';
import { NextPrevButton } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useNavigate } from 'react-router-dom';
import { useIsDesktop } from 'Hooks';
import { B2CIntro } from 'Images';

export const UserContacts = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();

  return (
    <Stack
      sx={{
        p: isDesktop ? '0 100px' : '0 24px',
        maxWidth: '600px',
      }}
    >
      {!isDesktop && (
        <Avatar
          alt=''
          src={B2CIntro}
          sx={{
            width: '85px',
            height: '85px',
            position: 'absolute',
            top: '30px',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />
      )}
      <Title />
      <Contacts />
      <NextPrevButton
        text={Dictionary[DICTIONARY.B2C].next}
        isNext
        isBlue
        callback={() => navigate('/')}
        style={{
          button: { margin: '0 auto' },
        }}
      />
    </Stack>
  );
};
